"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.financingPartnerSchema = exports.FINANCING_PARTNERS = void 0;
const zod_1 = require("zod");
// This mirrors Prisma's financing_partner_enum exactly; Rivonia is title-case there too. A drift test keeps the two in sync.
exports.FINANCING_PARTNERS = ['METYCLE', 'CALF', 'SCCF', 'Rivonia', 'YONGGANG'];
exports.financingPartnerSchema = zod_1.z.enum(exports.FINANCING_PARTNERS);
//# sourceMappingURL=financing.js.map